(function () {
  if (window.__ohCartV2) return;
  window.__ohCartV2 = true;

  var GIFT_TIER = 25000;
  var GIFT_MATCH = 'Discovery';
  var DISCOVERY_VARIANT = 51936928334048;
  var DISCOVERY_IMG = 'https://cdn.shopify.com/s/files/1/0774/5788/3360/files/IMG-0659.png?v=1779906369&width=220';
  var DISCOVERY_TITLE = 'Discovery Set';
  var VOUCHER_COPY = 'Your $35 comes back as a voucher toward any Full Set.';
  var CUTOFF_HOUR = 14;
  var TZ = 'America/Chicago';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(c) { var d = c / 100; return '$' + (c % 100 === 0 ? d : d.toFixed(2)); }
  function hasGift(cart) {
    return cart.items.some(function (i) { return (i.product_title || '').indexOf(GIFT_MATCH) !== -1; });
  }

  var fetchTimer = null, lastCart = null;
  function withCart(cb) {
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(function () {
      fetch(ROOT + 'cart.js').then(function (r) { return r.json(); })
        .then(function (c) { lastCart = c; cb(c); }).catch(function () {});
    }, 150);
  }

  function tierBar(cart) {
    var text = document.querySelector('.cart-drawer__ship-text');
    var fill = document.querySelector('.cart-drawer__ship-fill');
    if (!text || !fill || cart.total_price <= 0) return;
    var t = cart.total_price, html, pct;
    if (t < GIFT_TIER) {
      html = 'You\u2019re <b>' + money(GIFT_TIER - t) + '</b> from a free Discovery Set';
      pct = (t / GIFT_TIER) * 100;
    } else if (!hasGift(cart)) {
      html = '\u2713 <b>Free Discovery Set unlocked</b> \u00b7 add it below, it\u2019s on us';
      pct = 100;
    } else {
      html = '\u2713 Your <b>free Discovery Set</b> is in';
      pct = 100;
    }
    pct = Math.min(pct, 100).toFixed(1) + '%';
    if (text.innerHTML !== html) text.innerHTML = html;
    if (fill.style.width !== pct) fill.style.width = pct;
  }

  function giftBlock(cart) {
    var items = document.querySelector('.cart-drawer__items');
    if (!items) return;
    var unlocked = cart.total_price >= GIFT_TIER && !hasGift(cart);
    var ex = document.getElementById('ohgift');
    if (!unlocked) { if (ex) ex.remove(); return; }
    if (ex) return;
    var el = document.createElement('div');
    el.id = 'ohgift';
    el.className = 'ohgift';
    el.innerHTML =
      '<span class="ohgift__label">\u2713 Your free gift is unlocked</span>' +
      '<div class="ohgift__card">' +
        '<span class="ohgift__img"><img src="' + DISCOVERY_IMG + '" alt="' + DISCOVERY_TITLE + '" loading="lazy"></span>' +
        '<span class="ohgift__info">' +
          '<span class="ohgift__name">' + DISCOVERY_TITLE + '</span>' +
          '<span class="ohgift__price"><s>$35</s> Free</span>' +
        '</span>' +
        '<button type="button" class="ohgift__btn"><span>Add for Free</span></button>' +
      '</div>';
    var up = items.querySelector('.ourchived-upsell');
    if (up) { items.insertBefore(el, up); } else { items.appendChild(el); }
  }

  function refreshDrawer() {
    var comp = document.querySelector('cart-items-component');
    if (!comp) return;
    var sid = (comp.getAttribute('data-section-id') || '').replace(/^shopify-section-/, '');
    if (!sid) return;
    fetch(location.pathname + '?section_id=' + sid).then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-items-component');
        if (fresh) comp.innerHTML = fresh.innerHTML;
        var nb = doc.querySelector('.cart-bubble'), ob = document.querySelector('.cart-bubble');
        if (nb && ob) { ob.innerHTML = nb.innerHTML; ob.className = nb.className; }
        decorate();
      }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.ohgift__btn');
    if (!b || b.disabled) return;
    e.preventDefault(); e.stopPropagation();
    var lbl = b.querySelector('span') || b, o = lbl.textContent;
    b.disabled = true; lbl.textContent = 'Adding...';
    fetch(ROOT + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: DISCOVERY_VARIANT, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'unavailable'); });
      return r.json();
    }).then(function () { lbl.textContent = 'Added \u2713'; refreshDrawer(); })
      .catch(function () {
        lbl.textContent = 'Restocking soon';
        setTimeout(function () { lbl.textContent = o; b.disabled = false; }, 2600);
      });
  });

  function voucher(cart) {
    var giftedFree = cart.total_price >= GIFT_TIER;
    document.querySelectorAll('.cart-drawer .cart-items__table-row').forEach(function (row) {
      var title = row.querySelector('.cart-items__title');
      if (!title || title.textContent.indexOf(GIFT_MATCH) === -1) return;
      var details = row.querySelector('.cart-items__details');
      if (!details) return;
      var note = details.querySelector('.ourchived-voucher-note');
      if (giftedFree) { if (note) note.remove(); return; }
      if (note) return;
      var n = document.createElement('div');
      n.className = 'ourchived-voucher-note';
      n.textContent = VOUCHER_COPY;
      if (details.lastElementChild) details.insertBefore(n, details.lastElementChild);
      else details.appendChild(n);
    });
  }

  function cutoffText() {
    var now;
    try { now = new Date(new Date().toLocaleString('en-US', { timeZone: TZ })); } catch (e) { now = new Date(); }
    var day = now.getDay();
    if (day === 0 || day === 6) return 'Order now \u00b7 ships Monday morning';
    var cut = new Date(now); cut.setHours(CUTOFF_HOUR, 0, 0, 0);
    if (now < cut) {
      var mins = Math.floor((cut - now) / 60000), h = Math.floor(mins / 60), m = mins % 60;
      return 'Order in ' + (h > 0 ? h + 'h ' : '') + m + 'm \u00b7 ships today';
    }
    return day === 5 ? 'Order now \u00b7 ships Monday morning' : 'Order now \u00b7 ships tomorrow morning';
  }
  function cutoff() {
    var ctas = document.querySelector('.cart-drawer .cart__ctas');
    if (!ctas) return;
    var el = ctas.querySelector('.ourchived-cutoff');
    if (!el) {
      el = document.createElement('div'); el.className = 'ourchived-cutoff';
      var btn = ctas.querySelector('.cart__checkout-button');
      if (btn) ctas.insertBefore(el, btn); else ctas.appendChild(el);
    }
    var want = cutoffText();
    if (el.textContent !== want) el.textContent = want;
  }

  function decorate() {
    withCart(function (cart) {
      try { tierBar(cart); giftBlock(cart); voucher(cart); cutoff(); } catch (e) {}
    });
  }

  var obsTimer = null;
  var observer = new MutationObserver(function () {
    clearTimeout(obsTimer); obsTimer = setTimeout(decorate, 200);
  });
  function init() {
    decorate();
    observer.observe(document.body, { childList: true, subtree: true });
    setInterval(cutoff, 60000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
